<!-- 页面底部组件 -->
<template>
  <div class='page-footer'>
    <ul class='page-icon'>
      <!--@click="goWechat"-->
      <li>
        <img :src='wechat'
             alt='weChat' />
      </li>
      <li>
        <img :src='phone'
             alt='contact' />
        <div class='tips phone'>400-900-6017</div>
      </li>
      <li @click="goFeedback">
        <img :src='email'
             alt='feedback' />
      </li>
      <li>
        <img :src='address'
             alt='address' />
        <!-- <div class='tips address'>神州数码大厦5层&nbsp; &nbsp;中国-北京-海淀</div> -->
      </li>
    </ul>
    <div v-html="copyright" style="width: 100%;position:absolute;left: 50%;transform: translate(-50%, 0);bottom:20px;font-size: 12px;"></div>
    <!-- <p class='copy'>
      <span>Copyright ©-2019 北京华来荣信息技术有限公司</span>
      <span style="width:300px;margin:0 auto; padding:20px 0;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502046223" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img :src="jingbeian" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010502046223号</p></a>
      </span>
       <span>京ICP备14042096号-1</span>
    </p> -->
  </div>
</template>

<script>
import wechat from '@/assets/undergraduate/images/wechat.png'
import phone from '@/assets/undergraduate/images/phone.png'
import email from '@/assets/undergraduate/images/email.png'
import address from '@/assets/undergraduate/images/address.png'
import jingbeian from '@/assets/jingbeian.png'
import { copyright } from '@/constant'
export default {
  name: '',
  components: {},
  data () {
    return {
      wechat,
      phone,
      email,
      address,
      jingbeian,
      copyright
    }
  },
  computed: {},
  mounted () { },
  methods: {
    // 看微信
    goWechat () {
      this.$router.push({
        path: '/undergraduate/wechat'
      })
    },
    // 问题反馈
    goFeedback () {
      // this.$router.push({
      //   path: '/undergraduate/feedback'
      // })
    }
  }
}
</script>
<style lang='less' scoped>
.page-footer {
  box-sizing: border-box;
  padding: 40px 20px 60px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  min-width: 1240px;
  .page-icon {
    font-size: 0;
    text-align: center;
    > li {
      display: inline-block;
      width: 26px;
      height: 26px;
      margin: 16px;
      background: #eee;
      cursor: pointer;
      position: relative;
      &:hover {
        .tips {
          display: block;
        }
      }
      > img {
        width: 100%;
        height: 100%;
        border-radius: 26px;
        border: none;
        display: block;
      }
      .tips {
        width: 126px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
        font-size: 14px;
        color: #667483;
        text-align: center;
        box-shadow: 0 4px 8px 0 #e9f0fa;
        display: none;
        &::after {
          content: "";
          width: 0;
          height: 0;
          border: 8px solid transparent;
          border-top: 8px solid #fff;
          position: absolute;
          bottom: -16px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .phone {
        line-height: 40px;
        top: -50px;
      }
      .address {
        top: -58px;
        line-height: 24px;
      }
    }
  }
  .copy {
    font-size: 12px;
    color: #b1bcc8;
    letter-spacing: 0;
    text-align: center;
    margin: 0 auto;
  }
}
</style>
